import { repairAppearance } from './character/appearance.js';
import { FRAME_HEIGHT, FRAME_WIDTH, walkFrame } from './character/catalog.js';
import { moveAxis } from './movement.js';

const DIRECTION_ROWS = { down: 0, up: 1, left: 2, right: 3 };

export { FRAME_HEIGHT, FRAME_WIDTH };

export class Player {
  constructor(image, x = 0.5, y = 0.5, appearance = null) {
    this.image = image;
    this.appearance = repairAppearance(appearance);
    this.x = x;
    this.y = y;
    this.speed = 4.375;
    this.direction = 'down';
    this.walkTime = 0;
    this.moving = false;
    this.keys = new Set();
  }

  setKey(code, pressed) {
    if (pressed) this.keys.add(code);
    else this.keys.delete(code);
  }

  update(dt, world) {
    const horizontal = Number(this.keys.has('KeyD')) - Number(this.keys.has('KeyA'));
    const vertical = Number(this.keys.has('KeyS')) - Number(this.keys.has('KeyW'));
    this.moving = horizontal !== 0 || vertical !== 0;
    if (!this.moving) return;

    if (Math.abs(horizontal) > Math.abs(vertical)) this.direction = horizontal < 0 ? 'left' : 'right';
    else if (vertical) this.direction = vertical < 0 ? 'up' : 'down';

    const length = Math.hypot(horizontal, vertical);
    const distance = this.speed * dt;
    this._moveAxis(world, 'x', horizontal / length * distance);
    this._moveAxis(world, 'y', vertical / length * distance);
    this.walkTime += dt;
  }

  _moveAxis(world, axis, amount) {
    moveAxis(this, world, axis, amount);
  }

  draw(ctx, origin, tileSize) {
    const frame = this.moving ? walkFrame(this.walkTime, this.speed) : 0;
    const row = DIRECTION_ROWS[this.direction];
    const width = tileSize;
    const height = tileSize * 1.5;
    const screenX = Math.round(origin.x + this.x * tileSize - width / 2);
    const screenY = Math.round(origin.y + this.y * tileSize - height * 2 / 3);
    ctx.drawImage(
      this.image,
      frame * FRAME_WIDTH, row * FRAME_HEIGHT, FRAME_WIDTH, FRAME_HEIGHT,
      screenX, screenY, width, height,
    );
  }
}
